import { useRef, useState } from "react";
import api, { apiError, imageUrl } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { UploadSimple, X } from "@phosphor-icons/react";

export const ImageUpload = ({ value, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/upload/image", fd);
      onChange(data.path);
      toast.success("Foto caricata");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        <div className="relative">
          <img src={imageUrl(value)} alt="Foto" className="h-16 w-16 rounded-xl object-cover border border-[#E5E5E0]" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange(null)} data-testid={`${testId}-remove`} className="absolute -top-2 -right-2 h-5 w-5 rounded-full bg-[#D32F2F] text-white flex items-center justify-center hover:bg-red-700">
            <X size={12} />
          </button>
        </div>
      ) : (
        <div className="h-16 w-16 rounded-xl bg-[#FAF9F6] border border-dashed border-[#E5E5E0]" />
      )}
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={onFile} data-testid={`${testId}-input`} />
      <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => inputRef.current?.click()} data-testid={`${testId}-button`} className="rounded-full gap-2 hover:bg-stone-50">
        <UploadSimple size={16} /> {uploading ? "Caricamento..." : value ? "Cambia foto" : "Carica foto"}
      </Button>
    </div>
  );
};
